import { BlockStack, Card, InlineGrid, Page, Text } from '@shopify/polaris'
import { SectionSidebar } from '../../components/layout/SectionSidebar'
import { useEnabledModules } from '../../hooks/useEnabledModules'
import type { EnabledModules } from '../../hooks/useEnabledModules'

// Sections tied to a workflow enable-toggle disappear entirely when disabled.
// Operations and Delivery Tracking have no toggle and are always shown.
type SectionDef = {
  label:    string
  href:     string
  metrics:  string[]
  enabledKey?: keyof EnabledModules
}

const SECTIONS: SectionDef[] = [
  {
    label: 'Operations', href: '/workspace/operations',
    metrics: [],
  },
  {
    label: 'Confirmation', href: '/workspace/confirmation', enabledKey: 'confirmation',
    metrics: ['Pending', 'Assigned', 'Confirmed Today', 'Conversion Rate'],
  },
  {
    label: 'Shipping Confirmation', href: '/workspace/shipping-confirmation', enabledKey: 'shippingConfirmation',
    metrics: ['Pending', 'Assigned', 'Confirmed Today', 'Conversion Rate'],
  },
  {
    label: 'Customer Service', href: '/workspace/customer-service', enabledKey: 'customerService',
    metrics: ['Open Cases', 'Assigned', 'Resolved Today', 'Critical'],
  },
  {
    label: 'Sales Team', href: '/workspace/sales-team', enabledKey: 'sales',
    metrics: ['Pending', 'Assigned', 'Completed Today', 'Conversion Rate'],
  },
  {
    label: 'Delivery Tracking', href: '/workspace/delivery-tracking',
    metrics: ['Pending', 'Assigned', 'Delivered Today', 'Failed Attempts'],
  },
]

export function WorkspaceOverviewPage() {
  const enabled = useEnabledModules()

  const visible = SECTIONS.filter((s) => !s.enabledKey || enabled[s.enabledKey])

  return (
    <Page title="Workspace">
      <div style={{ display: 'flex', gap: '24px', alignItems: 'flex-start' }}>
        <SectionSidebar items={visible.map(({ label, href }) => ({ label, href }))} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <BlockStack gap="500">
            {visible.filter((s) => s.metrics.length > 0).map((row) => (
              <BlockStack gap="200" key={row.label}>
                <Text as="h2" variant="headingMd">{row.label}</Text>
                <InlineGrid columns={4} gap="300">
                  {row.metrics.map((label) => (
                    <Card key={label}>
                      <BlockStack gap="100">
                        <Text as="p" variant="bodySm" tone="subdued">{label}</Text>
                        <Text as="p" variant="headingXl" tone="subdued">—</Text>
                      </BlockStack>
                    </Card>
                  ))}
                </InlineGrid>
              </BlockStack>
            ))}
          </BlockStack>
        </div>
      </div>
    </Page>
  )
}
